export const validateWeavingAlertBody = (body) => {
    const {product} = body;
    if(product === undefined || product === null || product === '') throw new Error('Product is empty');
}

export const buildWeavingAlert = () => {
    return{
        product: '',
        active: 1,
        created_at: new Date().toISOString(),
    }
}